<template>
  <div>
    <div class="p-6 md:p-0 md:pt-6">
      <div class="flex items-center justify-center md:justify-between mb-6">
        <img
          class="md:hidden block w-12"
          src="/img/logo-yuk-belajar.png"
          alt="Yuk Belajar">
        <h1 class="hidden md:block font-semibold text-xl text-blue-900">
          Verifikasi
        </h1>
      </div>
      <div
        v-if="$store.state.user != null"
        class="w-full mb-4 leading-snug flex flex-col items-center justify-center text-gray-800">
        <div class="font-extrabold text-lg">
          {{ $store.state.user.name }}
        </div>
        <div class="font-medium text-base">
          {{ $store.state.user.email }}
        </div>
      </div>
      <div class="flex flex-wrap items-stretch justify-between">
        <div class="px-3 py-8 w-full bg-gray-100 rounded-lg text-gray-800 text-center">
          <div class="text-lg mb-10 font-bold">
            Verifikasi Alamat E-mail
          </div>
          <div class="text-sm leading-relaxed mb-5">
            Sebelum melanjutkan, cek e-mail untuk melihat tautan verifikasi.
          </div>
          <div class="text-sm leading-relaxed mb-5">
            Pastikan kamu telah mengisikan alamat email dengan benar.
          </div>
          <div class="text-sm leading-relaxed mb-5">
            Jika kamu menggunakan Gmail, pastikan kuota Google Drive-mu tidak penuh.
          </div>
          <div class="text-sm leading-relaxed mb-5">
            Harap tunggu e-mail tersebut maksimal 1 jam.
          </div>
          <!-- <div v-if="canResend" class="text-sm leading-relaxed mb-3">Jika kamu tidak menerima e-mail tersebut, <a @click="resend()" :disabled="$store.state.loading" class="text-blue-600" href="#">klik di sini</a> agar kami coba kirim ulang e-mail verifikasi.</div> -->
          <div class="text-sm leading-relaxed mb-5">
            Jika kamu salah memasukkan nama atau e-mail, silakan <button
              class="text-blue-600"
              @click="deleteUser()">
              hapus akun
            </button> ini kemudian daftarkan yang baru.
          </div>
          <div class="text-sm leading-relaxed mb-5">
            Silakan hubungi Customer Support kami jika semua informasi tersebut tidak membantumu dalam proses verifikasi e-mail ini.
          </div>
        </div>
      </div>
      <div class="text-center mb-6">
        <logout-button />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      canResend: true,
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.$store.commit('setCurrentPath', 'profile');
    })
  },
  methods: {
    async resend() {
      this.$store.commit('setLoading', true);
      this.canResend = false;
      try {
        await axios.post('/email/resend');
      } catch (error) {
        this.$store.commit('setLoading', false);
        this.canResend = true;
        throw error;
      }
      this.$store.commit('setLoading', false);
    },
    async deleteUser() {
      await axios.post('/user/delete');
      window.location.href = "/register";
    },
  },
}
</script>
